import React from 'react';
import merge from 'lodash/merge';
import {Col, Form, Row} from 'react-bootstrap';
import {Action} from '../../../system/buttons';
import {ValorantWidgetProps} from '@pulsoid-private/widgets-lib';
import ColorPicker from './ColorPicker';

const DEFAULT_CONFIG = {
  triggerHeartRate: 100,
  defaultColor: '#000000',
  afterTriggerColor: '#FF0000',
};

export const ValorantWidgetV2Edit = (props) => {
  const [configuration, setConfiguration] = React.useState<
    ValorantWidgetProps['configuration']
  >(merge(props.configuration));

  const updateConfiguration = (configPart: Partial<typeof DEFAULT_CONFIG>) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  const handleOnSave = () => {
    props.onSave(configuration);
  };

  return (
    <>
      <Form.Group as={Row}>
        <Form.Label column htmlFor="defaultColor" sm="2">
          Default color
        </Form.Label>
        <Col sm="6">
          <ColorPicker
            color={configuration.defaultColor}
            onChangeComplete={(color) =>
              updateConfiguration({defaultColor: color})
            }
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column htmlFor="triggerHeartRate" sm="2">
          Trigger heart rate
        </Form.Label>
        <Col sm="6">
          <Form.Control
            id="triggerHeartRate"
            type="number"
            value={configuration.triggerHeartRate}
            onChange={(e) =>
              updateConfiguration({triggerHeartRate: Number(e.target.value)})
            }
          />
        </Col>
      </Form.Group>

      <Form.Group as={Row}>
        <Form.Label column htmlFor="afterTriggerColor" sm="2">
          After trigger color
        </Form.Label>
        <Col sm="6">
          <ColorPicker
            color={configuration.afterTriggerColor}
            onChangeComplete={(color) =>
              updateConfiguration({afterTriggerColor: color})
            }
          />
        </Col>
      </Form.Group>

      <Action onClick={handleOnSave}>Save settings</Action>
    </>
  );
};
